import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-how_can_i_help_to_help_center_next-click';
/**
 * Tracking the next btn from &quot;How can I help you&quot; to &quot;Help center articles&quot;
 */
export function trackCxFoundationsHowCanIHelpToHelpCenterNextClick(issueTree, retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { issueTree, retailerToken, brandToken },
    });
}
